import { Box, IconButton, styled, useTheme } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { Icon } from '../../icons';

interface Props {
  onClick: () => void;
}

const MapSearchButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.contrastText,
  boxShadow: theme.shadows[3],
  '&:hover': {
    backgroundColor: theme.palette.grey['50'],
  },
}));

export const SearchButton: FC<Props> = ({ onClick }) => {
  const theme = useTheme();
  return (
    <Box top='66px' right={theme.spacing(2)} position='absolute' zIndex={800} >
      <MapSearchButton
        color="primary"
        data-testid="map-search-button"
        onClick={onClick}
      >
        <Icon icon="Search" style={{ fontSize: '1.5rem' }} />
      </MapSearchButton>
    </Box>

  );
};
